"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _FoodMenu = require("../../../FoodMenu.context");

var _index = require("../index");

var _menu = _interopRequireDefault(require("../../../utils/menu"));

var _ScheduleAvailability = _interopRequireDefault(require("../navigation/ScheduleAvailability"));

function CategoryContainer(_ref) {
  var scheduleId = _ref.scheduleId;
  return _react["default"].createElement(_FoodMenu.MenuConsumer, null, function (_ref2) {
    var schedules = _ref2.schedules,
        categories = _ref2.categories;

    var schedule = _menu["default"].getScheduleById(schedules, scheduleId);

    var scheduleCategoryIds = schedule.categories,
        availableDays = schedule.available_days,
        startTime = schedule.start_time,
        endTime = schedule.end_time;

    var scheduleCategories = _menu["default"].getScheduleCategories(scheduleCategoryIds, categories);

    return _react["default"].createElement(_FoodMenu.VariantConsumer, null, function (_ref3) {
      var categoryDisplay = _ref3.categoryDisplay;
      var CategoryComponent = _index.displayVariantComponentMap.category[categoryDisplay];
      var categories = scheduleCategories.map(function (_ref4) {
        var id = _ref4.id;
        return _react["default"].createElement(CategoryComponent, {
          categoryId: id,
          key: id
        });
      });

      if (categoryDisplay === 'Column') {
        return _react["default"].createElement("div", null, _react["default"].createElement(_ScheduleAvailability["default"], {
          availableDays: availableDays,
          startTime: startTime,
          endTime: endTime
        }), _react["default"].createElement(_semanticUiReact.Grid, {
          stackable: true,
          columns: 2
        }, categories));
      }

      return _react["default"].createElement("div", null, _react["default"].createElement(_ScheduleAvailability["default"], {
        availableDays: availableDays,
        startTime: startTime,
        endTime: endTime
      }), categories);
    });
  });
}

var _default = CategoryContainer;
exports["default"] = _default;